import { FC } from 'react';
import {
  SIZE_ABBREVIATIONS_IN_WAIST_LENGTH_MAP,
  SIZE_ABBREVIATIONS_MAP,
} from '~/common/constants/product';
import { ProductSettings } from '~/sections/product/SelectionControls';
import { Typography } from '../typography/Typography';
import { ItemDisplayContainer, SizeItem } from './Item';
import { SIZE_ABBREVIATIONS_MAP_TO_SIZE_STARS } from './SizeStars';

interface SizeItemsProps {
  sizes: Array<{ size: string; available: boolean }>;
  setProductSettings?: React.Dispatch<React.SetStateAction<ProductSettings>>;
  selectedSize: string;
  onClick?: (size: string) => void;
  title: string;
  showStars?: boolean;
  strokeColor?: string;
}

const SizeItems: FC<SizeItemsProps> = ({
  sizes,
  setProductSettings,
  selectedSize,
  onClick,
  title,
  showStars,
  strokeColor,
}) => (
  <ItemDisplayContainer>
    {sizes.map((sizeObj) => {
      const sizeName =
        SIZE_ABBREVIATIONS_MAP[
          sizeObj.size as keyof typeof SIZE_ABBREVIATIONS_MAP
        ];

      const sizeNameInWL =
        SIZE_ABBREVIATIONS_IN_WAIST_LENGTH_MAP[
          sizeObj.size as keyof typeof SIZE_ABBREVIATIONS_IN_WAIST_LENGTH_MAP
        ];

      const SizeComponent = (() => {
        if (
          showStars &&
          Object.hasOwn(SIZE_ABBREVIATIONS_MAP_TO_SIZE_STARS, sizeObj.size)
        ) {
          return SIZE_ABBREVIATIONS_MAP_TO_SIZE_STARS[
            sizeObj.size as keyof typeof SIZE_ABBREVIATIONS_MAP_TO_SIZE_STARS
          ];
        }

        return SizeItem;
      })();

      return sizeName ? (
        <SizeComponent
          key={title + ' ' + sizeObj.size}
          available={sizeObj.available}
          strokeColor={strokeColor}
          onClick={() => {
            if (!sizeObj.available) {
              return;
            }
            setProductSettings?.((prev) => ({
              ...prev,
              selectedSize: sizeObj.size,
            }));
            onClick?.(sizeObj.size);
          }}
          selected={sizeObj.size === selectedSize}
          width={sizeNameInWL && '4rem'}
          borderRadius={sizeNameInWL && '1.25rem'}
        >
          {!showStars && (
            <Typography variant="subtitle1">{sizeName}</Typography>
          )}
        </SizeComponent>
      ) : null;
    })}
  </ItemDisplayContainer>
);

export default SizeItems;
